import cx from 'classnames';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useEffect } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ChacharPage = (props: Props): JSX.Element => {
    useEffect(() => {
        Localization.setLanguage('cs');
    }, []);

    return (
        <S_ChacharPage className={cx(props.className, 'cleanmap')}>
            <CustomMapPage
                mapId={'3e809433-cf51-461a-b060-a0acbf2ab9dc'}
                disableSimpleGestures={true}
                forceInitialPositionBounds={true}
            />
        </S_ChacharPage>
    );
};

const S_ChacharPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
